import styled from "styled-components";

import { Frame, Row, RowWrapper, TExtra } from "components/ui-kit/styled-templates";

import { resolveFileUrl } from "constants/config";

import ModalsService from "services/modals-service";

import useDeviceParams from "hooks/useDeviceParams";
import usePagination from "hooks/usePagination";

import { EModals } from "types/enums";

type TProps = {
    photos: string[];
    extra?: TExtra;
};

const Gallery = {
    Component: (props: TProps) => {
        const { photos, extra = `` } = props;

        const photosPagination = usePagination(photos, { perPage: 4 });
        const {
            visibleItems: visiblePhotos,
            isFirstPage: isFirstPhotoPage,
            isLastPage: isLastPhotoPage,
            handleNextPage,
            handlePrevPage,
        } = photosPagination;

        const { isDesktop } = useDeviceParams();

        return (
            <RowWrapper extra={`margin-top: 56px; @media (max-width: 991px) { width: 100vw; margin-left: -7vw; overflow-x: scroll; }; ${extra}`}>
                {isDesktop && <Gallery.SvgArrow direction="left" isActive={!isFirstPhotoPage} onClick={handlePrevPage} />}
                <Row
                    extra={`width: 100%; gap: 0 27px; @media (max-width: 991px) { width: max-content; > * { &:first-child { margin-left: 7vw; }; &:last-child { margin-right: 7vw; }; }; };`}
                >
                    {(isDesktop ? visiblePhotos : photos).map((item: string, index: number) => (
                        <Gallery.Photo
                            key={index}
                            src={resolveFileUrl(item)}
                            onClick={() => ModalsService.showModal(EModals.OverlayedGallery, { photos, currentPhotoNumber: index })}
                        />
                    ))}
                </Row>
                {isDesktop && <Gallery.SvgArrow direction="right" isActive={!isLastPhotoPage} onClick={handleNextPage} />}
            </RowWrapper>
        );
    },
    Wrapper: styled(Frame)``,
    Photo: styled(Frame)<{ src: string }>`
        width: 276px;
        height: 195px;
        border-radius: 8px;

        background: url("${({ src }) => src}") no-repeat center center / cover;
    `,
    SvgArrow: styled.svg.attrs((props) => {
        return {
            ...props,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: (
                <>
                    <defs>
                        <style>{`.cls-1{fill:none;}`}</style>
                    </defs>
                    <g id="wrapper">
                        <rect className="cls-1" width="24" height="24" />
                    </g>
                    <path d="M14.55,12,11.2,9.1,6.78,5.32a1.29,1.29,0,0,1-.51-1.18,1.28,1.28,0,0,1,2.12-.81l2.32,2,6.51,5.57a1.27,1.27,0,0,1,.53,1.37,1.67,1.67,0,0,1-.44.72q-4.48,3.87-9,7.7a1.26,1.26,0,0,1-1.81-.13,1.28,1.28,0,0,1,.18-1.84L14.3,12.2Z" />
                </>
            ),
        };
    })<{ direction: `left` | `right`; isActive: boolean }>`
        ${({ direction }) => direction === `left` && `transform: rotate(180deg);`}

        width: 30px;
        height: 30px;

        cursor: pointer;

        path {
            fill: ${({ theme, isActive }) => (isActive ? theme.blue : theme.grey)};
        }
    `,
};

export default Gallery.Component;
